<ng-container *ngIf="keyAccounts; else normalProductCard">
  <ion-card
    mode="md"
    color="white"
    class="card-product card-product-key-accounts"
  >
    <ion-icon
      [src]="'Icons.specials-month-tag' | translate"
      class="icon-recommended"
    ></ion-icon>

    <ion-img [src]="product.imagen" class="image-keyAccounts"></ion-img>

    <ion-item mode="md" color="transparent">
      <ion-label mode="md" class="ion-text-center no-margin-bottom">
        <p class="mpe-font-weight-600">
          <ion-text color="status-icon-enable" mode="md">
            {{ product.title }}
          </ion-text>
        </p>
        <p class="subtitle">
          <ion-text color="status-icon-enable" mode="md">
            {{ product.subtitle }}
          </ion-text>
        </p>

        <p class="mpe-font-weight-600 price">
          <ion-text color="tpcta">
            {{ product.precio | currency }}
          </ion-text>
        </p>
      </ion-label>
    </ion-item>

    <ion-item mode="md" color="transparent">
      <range-input
        slot="start"
        class="no-margin"
        [initial]="productsSelect"
        [configurations]="rangeInput"
        (comeBack)="comeBack($event)"
      ></range-input>

      <ion-button
        slot="end"
        color="tpcta"
        class="buttom-add ion-text-capitalize no-margin"
        size="small"
        (click)="onAddCart(product)"
        [disabled]="isDisabled"
      >
        <ng-container *ngIf="state; then add; else upgrade"></ng-container>
        <ng-template #add>
          {{ "Buttons.add" | translate }}
        </ng-template>
        <ng-template #upgrade>
          {{ "Buttons.upgrade" | translate }}
        </ng-template>
      </ion-button>
    </ion-item>

    <ng-container *ngIf="product.Etiquetados">
      <div class="content-keyAccounts-etiquetados">
        <ion-button
          class="mpe-button-icon-circle ion-no-padding button-etiquetados"
          size="default"
          mode="ios"
          shape="round"
          [color]="
            'Miscellaneous.etiquetados.' + product.TipoEnvase + '.color'
              | translate
          "
          disabled
        >
          <ion-icon
            [src]="
              'Miscellaneous.etiquetados.' + product.TipoEnvase + '.icon'
                | translate
            "
          ></ion-icon>
        </ion-button>
        <ion-chip
          [color]="
            'Miscellaneous.etiquetados.' + product.TipoEnvase + '.color'
              | translate
          "
          disabled
          class="chip-etiquetados chip-etiquetados-2"
          [innerHTML]="
            'Miscellaneous.etiquetados.' + product.TipoEnvase + '.label'
              | translate : { presentacion: '' }
              | htmlSeguro
          "
        >
        </ion-chip>
      </div>
    </ng-container>
  </ion-card>
</ng-container>

<ng-template #normalProductCard>
  <ion-card mode="md" color="white" class="card-product">
    <ion-grid fixed *ngIf="!isPreviousValue" class="animated fadeIn fast">
      <ion-row class="content-row">
        <ng-container *ngIf="product.modelo === 0 || product.modelo === 1">
          <ion-icon
            [src]="
              'Icons.' +
                (product.modelo === 0 ? 'bottle-start-tag' : 'box-check-tag')
                | translate
            "
            class="icon-recommended"
          ></ion-icon>
        </ng-container>

        <ng-container *ngIf="product.Etiquetados">
          <ion-button
            class="mpe-button-icon-circle ion-no-padding"
            size="default"
            mode="ios"
            shape="round"
            [color]="
              'Miscellaneous.etiquetados.' + product.TipoEnvase + '.color'
                | translate
            "
            disabled
          >
            <ion-icon
              [src]="
                'Miscellaneous.etiquetados.' + product.TipoEnvase + '.icon'
                  | translate
              "
            ></ion-icon>
          </ion-button>
          <ion-chip
            [color]="
              'Miscellaneous.etiquetados.' + product.TipoEnvase + '.color'
                | translate
            "
            disabled
            class="chip-etiquetados"
            [innerHTML]="
              'Miscellaneous.etiquetados.' + product.TipoEnvase + '.label'
                | translate : { presentacion: '' }
                | htmlSeguro
            "
          >
          </ion-chip>
        </ng-container>

        <!-- ? Imagen del producto -->
        <ion-col size="3" class="ion-align-self-center">
          <ion-img [src]="product.imagen" class="image"></ion-img>
        </ion-col>

        <!-- ? Detalle del producto -->
        <ion-col
          [size]="addDown ? 9 : colDescrip"
          class="ion-align-self-center ion-text-start"
        >
          <ion-label mode="md">
            <p class="mpe-font-weight-600" [attr.data-test]="'Automation.txt-productcard-title' | translate">
              {{ product.title }}
            </p>
            <p class="subtitle" [attr.data-test]="'Automation.txt-productcard-presentation' | translate">
              {{ product.subtitle }}
            </p>

            <p class="subtitle" [attr.data-test]="'Automation.txt-productcard-flavor' | translate">
              {{ "Labels.taste" | translate }}:&nbsp;{{ product.sku }}
            </p>

            <ng-container *ngIf="claveProducto">
              <p class="sku">
                <ion-text mode="md" color="medium" [attr.data-test]="'Automation.txt-productcard-sku' | translate">
                  {{ "Labels.sku" | translate }}:&nbsp;{{ claveProducto }}
                </ion-text>

                <ng-container *ngIf="!isFactorCl">
                  <b [attr.data-test]="'Automation.txt-productcard-factorcl' | translate">
                    {{ "Labels.factorcl" | translate }}: {{ product.FactorCl }}
                  </b>
                </ng-container>
              </p>
            </ng-container>

            <p class="mpe-font-weight-600">
              <ion-text color="tpcta" [attr.data-test]="'Automation.txt-productcard-price' | translate">
                {{ product.precio | currency }}
              </ion-text>
            </p>
          </ion-label>
        </ion-col>

        <!-- ? Botones de seleccionar y agregar -->
        <ion-col
          [size]="addDown ? 12 : colButtoms"
          class="ion-align-self-center ion-text-center col-buttoms"
          [ngClass]="{ 'horizontal-buttons': addDown }"
        >
          <ng-container *ngIf="resetRange; else resetRangeFalse">
            <ion-skeleton-text
              style="width: 80px; height: 30px"
            ></ion-skeleton-text>
          </ng-container>

          <ng-template #resetRangeFalse>
            <range-input
              [initial]="productsSelect"
              [configurations]="rangeInput"
              (comeBack)="comeBack($event)"
            ></range-input>
          </ng-template>

          <ion-button
            [attr.data-test]="'Automation.btn-productcard-add' | translate"
            color="tpcta"
            class="buttom-add ion-text-capitalize"
            size="small"
            (click)="onAddCart(product)"
            [disabled]="isDisabled"
          >
            <ng-container *ngIf="state; then add; else upgrade"></ng-container>
            <ng-template #add>
              {{ "Buttons.add" | translate }}
            </ng-template>
            <ng-template #upgrade>
              {{ "Buttons.upgrade" | translate }}
            </ng-template>
          </ion-button>

          <ng-container
            *ngIf="
              (cajasSugeridas > 0 && product.modelo === 0) ||
              product.Multiplicador > 0
            "
          >
            <ion-label
             [attr.data-test]="'Automation.txt-productcard-suggestedbox' | translate"
              mode="md"
              color="cadet-grey"
              class="suggested-boxes"
              [ngClass]="{ 'suggested-model': addDown }"
            >
              {{
                "Labels.suggested-boxes" | translate : { cajas: cajasSugeridas }
              }}
            </ion-label>
          </ng-container>
        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- ! Animaciones -->
    <ion-grid fixed *ngIf="isPreviousValue" class="skeleton-grid">
      <ion-row>
        <ion-col size="3" class="ion-align-self-center">
          <ion-skeleton-text
            animated
            class="skeleton-image image"
          ></ion-skeleton-text>
        </ion-col>

        <ion-col [size]="colDescrip" class="ion-align-self-center">
          <ng-container *ngFor="let item of [1, 2, 3, 4]">
            <ion-skeleton-text
              animated
              class="skeleton-text"
            ></ion-skeleton-text>
          </ng-container>
        </ion-col>

        <ion-col [size]="colButtoms" class="ion-align-self-center col-buttoms">
          <ng-container *ngFor="let item of [1, 2]">
            <ion-skeleton-text
              animated
              class="skeleton-buttom buttom-add"
            ></ion-skeleton-text>
          </ng-container>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>
</ng-template>
